import { useStoreCaseConfiguration } from '@/Store/storeCaseConfiguration';

export function savePreset(namePreset = 'preset_default') {
    function download(content, fileName, contentType) {
        const a = document.createElement('a');
        const file = new Blob([ content ], { type: contentType });
        a.href = URL.createObjectURL(file);
        a.download = fileName;
        a.click();
    }
    const content = useStoreCaseConfiguration().$state;
    const name = { name: namePreset, selectedCasePresetId: crypto.randomUUID() };
    const res = Object.assign(content, name);
    delete res.itemsFromApi;
    download(JSON.stringify(res), 'data.json', 'text/plain');
}
